<template>
    <div :style="styles.container" class="equipments-facility-modal-container">
        <div :style="styles.wrapper" class="modal-wrapper">
            <slot name="header"></slot>
            <div :style="styles.content" class="settings-wrapper">
                <div v-for="setting in settings" :key="setting.name" class="setting">
                    <div class="form-check form-fields">
                        <input
                            :name="setting.name"
                            v-model="setting.selected"
                            class="form-check-input"
                            :id="setting.name"
                            type="checkbox"
                        />
                        <label class="form-check-label" :for="setting.name">
                            {{ setting.label }}
                        </label>
                        <input
                            v-if="!screen.isMobile.value"
                            v-model="setting.description"
                            type="text"
                            maxlength="100"
                            placeholder="Specify: quantity, type, etc."
                        />
                    </div>
                </div>
            </div>
            <slot name="footer"></slot>
        </div>
    </div>
</template>
<script>
    import useCheckScreen from '@/composables/useCheckScreen.js'
    export default {
        name: 'FacilitiesModal',
        props: {
            settings: {
                required: true,
                type: Array
            },
            styles: {
                required: false,
                type: Object,
                default: () => ({})
            }
        },
        setup() {
            const { isMobile } = useCheckScreen()
            return {
                screen: {
                    isMobile
                }
            }
        }
    }
</script>
<style lang="scss" scoped>
    $mobileMax: 600px;
    @media screen and (max-width: $mobileMax) {
        .equipments-facility-modal-container {
            padding: 32px 16px !important;
            max-height: 500px !important;
        }

        .settings-wrapper {
            align-items: flex-start;

            .setting {
                width: 100%;

                .form-check-input {
                    margin-left: 2px;
                }
            }
        }

        .form-fields {
            padding: 16px 16px;
            border-radius: 8px;
            background: #333;
        }
    }
    .input-err-msg {
        color: #dc3545;
        margin-bottom: 10px;
        margin-left: 5px;
    }
    .equipments-facility-modal-container::-webkit-scrollbar {
        display: none; /* Safari and Chrome */
    }
    .equipments-facility-modal-container {
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: flex-start;
        background: #262626;
        max-width: 1060px;
        max-height: 700px;
        width: 100%;
        padding: 48px 80px;
        border-radius: 15px;
        overflow-y: auto;
        -ms-overflow-style: none; /* Internet Explorer 10+ */
        scrollbar-width: none; /* Firefox */

        .settings-wrapper {
            margin-top: 59px;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            row-gap: 25px;

            .setting {
                .form-fields {
                    display: flex;
                    flex-direction: row;

                    .form-check-input {
                        border-radius: 5px;
                        border: 1.5px solid #8b8b8b;
                        background-color: transparent;
                        min-width: 20px;
                        max-width: 20px;
                        width: 100%;
                        height: 20px;
                    }

                    label {
                        margin-left: 10px;
                        color: #8b8b8b;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        font-family: Instrument Sans;
                        font-size: 20px;
                        font-style: normal;
                        font-weight: 550;
                        line-height: 120%;
                        letter-spacing: -0.2px;
                        min-width: 250px;
                    }

                    input[type='text'] {
                        min-width: 629px;
                        padding: 12px 15px 15px 15px;
                        border-radius: 12px;
                        border: 1.5px solid #8b8b8b;
                        background: #262626;
                        color: #f5f5f5;
                        font-family: Instrument Sans;
                        font-size: 20px;
                        font-style: normal;
                        font-weight: 550;
                        line-height: 120%;
                        letter-spacing: -0.2px;
                    }

                    input[type='text']::placeholder {
                        color: #8b8b8b;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        font-family: Instrument Sans;
                        font-size: 20px;
                        font-style: normal;
                        font-weight: 550;
                        line-height: 120%;
                        letter-spacing: -0.2px;
                    }
                }
            }
        }
    }
</style>
